module.exports = __webpack_public_path__ + "static/media/DSC_0071.0b7ea0be.jpg";